import { type Components } from 'react-markdown'
import { GDSMarkdown } from '../gdsMarkdown'

import { StreamingMarkdownContent } from '../streamingMarkdownContent'

interface Props {
  /**
   * The Markdown content to render.
   */
  content: string
  /**
   *  Whether the content is still streaming.
   */
  isStreaming: boolean
  /**
   * Update the default component map.
   */
  updateComponents?: (defaultComponentMap: Components) => Components
}

/**
 * Renders a block of text content as Markdown.
 */
export function StreamingMarkdown(props: Props) {
  return props.isStreaming ? (
    <StreamingMarkdownContent updateComponents={props.updateComponents}>
      {props.content}
    </StreamingMarkdownContent>
  ) : (
    <GDSMarkdown updateComponents={props.updateComponents}>{props.content}</GDSMarkdown>
  )
}
